import { Text, VStack } from '@chakra-ui/react';
import React from 'react';

import type { NavItem } from 'types/client/navigation';

type Props = {
  item: NavItem;
};

const NotificationItem = ({ item }: Props) => {
  return (
    <VStack as="li" listStyleType="none" alignItems="flex-start" w="100%" p={ 2 }>
      <Text fontWeight="bold">{ item.text }</Text>
      { item.description && <Text whiteSpace="pre-wrap">{ item.description }</Text> }
    </VStack>
  );
};

export default React.memo(NotificationItem);

